import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCancel = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.59992 15.333L11.9999 12.933L14.3999 15.333L15.3333 14.3997L12.9333 11.9997L15.3333 9.59967L14.3999 8.66634L11.9999 11.0663L9.59992 8.66634L8.66659 9.59967L11.0666 11.9997L8.66659 14.3997L9.59992 15.333ZM11.9999 18.6663C11.0777 18.6663 10.211 18.4913 9.39992 18.1413C8.58881 17.7913 7.88325 17.3163 7.28325 16.7163C6.68325 16.1163 6.20825 15.4108 5.85825 14.5997C5.50825 13.7886 5.33325 12.9219 5.33325 11.9997C5.33325 11.0775 5.50825 10.2108 5.85825 9.39967C6.20825 8.58856 6.68325 7.88301 7.28325 7.28301C7.88325 6.68301 8.58881 6.20801 9.39992 5.85801C10.211 5.50801 11.0777 5.33301 11.9999 5.33301C12.9221 5.33301 13.7888 5.50801 14.5999 5.85801C15.411 6.20801 16.1166 6.68301 16.7166 7.28301C17.3166 7.88301 17.7916 8.58856 18.1416 9.39967C18.4916 10.2108 18.6666 11.0775 18.6666 11.9997C18.6666 12.9219 18.4916 13.7886 18.1416 14.5997C17.7916 15.4108 17.3166 16.1163 16.7166 16.7163C16.1166 17.3163 15.411 17.7913 14.5999 18.1413C13.7888 18.4913 12.9221 18.6663 11.9999 18.6663Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgCancel);
export default ForwardRef;
